import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { ViewProvider } from '../../providers/view/view';
import { DadosProvider } from '../../providers/dados/dados';

@Component({
  selector: 'page-meus-dados',
  templateUrl: 'meus-dados.html',
})
export class MeusDadosPage {

  cliente:any = {};

  constructor(public navCtrl: NavController, public navParams: NavParams,public view:ViewProvider ,public server:SemovelProvider, public dadosP:DadosProvider) {
    this.carregarDados();
  }


  carregarDados() {
    this.server.postData({method:"cliente/view"})
    .subscribe(
      (dados) => {
        this.cliente = dados;
      },
      (erro) => {
        this.view.showMessage("Não foi possível carregar os dados. "+erro);
      }
    );
  }
  
  alterarSenha(){
  }
  
  validar(){
    if(!this.cliente.nome || this.cliente.nome.length <= 0 ){
      this.view.showMessage("É necessário informar o nome.");
      return false;
    }
  
    if(!this.cliente.telefone || this.cliente.telefone.length <= 0 ){
      this.view.showMessage("É necessário informar o telefone.");
      return false;
    }

    return true;
  }

  alterar(){
    if(!this.validar()){
      return;
    }

    this.server.postData({method:"cliente/update"}, this.cliente).subscribe(
      (dados) => {
        this.cliente = dados;
        this.view.showMessage("Dados salvos com sucesso. ");
        this.dadosP.salvarCliente(dados);
      },
      
      (erro) => {
        this.view.showMessage("Não foi possível carregar os dados. "+erro);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/meus-dados/meus-dados.ts